import { render, staticRenderFns } from "./examResult.vue?vue&type=template&id=1d022412&scoped=true"
import script from "./examResult.vue?vue&type=script&lang=js"
export * from "./examResult.vue?vue&type=script&lang=js"
import style0 from "./examResult.vue?vue&type=style&index=0&id=1d022412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d022412",
  null
  
)

export default component.exports